'use strict'

export default function ()
{

	function _apply ( element )
	{
		element.style.height = window.innerHeight + 'px'
	}

	return {
		restrict: 'A',
		scope: {},
		link: function ( scope, elements, attrs )
			{
				angular.forEach(elements, _apply)
			}
	}
}


// WEBPACK FOOTER //
// ./src/app/directives/sub-page/sub-page.directive.js